import { Box } from "@mui/material"
import { alpha, styled } from "@mui/material/styles"

// Enhanced header with better spacing and visuals
export const TableHeader = styled(Box)(({ theme }) => ({
	backgroundColor:
		theme.palette.mode === "dark"
			? alpha(theme.palette.background.paper, 0.6)
			: alpha(theme.palette.background.paper, 0.8),
	borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
	display: "flex",
	justifyContent: "flex-end",
	alignItems: "center",
	padding: theme.spacing(1.5, 2),
	zIndex: 3,
	backdropFilter: "blur(10px)",
	boxShadow: `0 1px 3px ${alpha(theme.palette.common.black, 0.04)}`,
}))
